<template>
  <div>

    <div v-if="!store.questions">
      <div v-if="!store.loading"
        class="deck deck--grey pa-1">
        {{t('MessageNoQuestionsNotLoading')}}
      </div>
      <div v-if="store.loading"
        class="deck deck--grey pa-1">
        <span class="spinner spinner--inline-block mr-1"></span>
        <span v-if="store.cvr">
          {{t('MessageNoQuestionsLoadingCvr', store.cvr )}}
        </span>
        <span v-if="!store.cvr">
          {{t('MessageNoQuestionsLoadingNoCvr')}}
        </span>
      </div>
    </div>

    <div v-if="store.questions">
      <div v-if="store.redirecting"
        class="deck deck--grey pa-1">
        <span class="spinner spinner--inline-block mr-1"></span>
          {{t('MessageQuestionsRedirecting', store.cvr )}}
      </div>
      <div v-if="!store.redirecting"
        class="deck deck--grey">
        <div class="order-flow">
          <OrderFlow
            v-for="(question, index) in store.questions"
            :key="index"
            :number="index+1"
            :open="step == index"
            :done="step > index"
            :clickable-headline="step >= index"
            @goto="doGotoStep(index)"
            :modifier="getStepModifier(index)"
            :headline="question.title"
          >
            <QuestionCvr
              v-if="question.id === 'cvr'"
              @next="doGotoStep(index+1)"
              @find="doFindCvr()"
              :company="store.company"
              :question="question"
            ></QuestionCvr>
            <QuestionsInput
              v-else
              @next="doGotoStep(index+1)"
              :show="step == index"
              :question="question"
            ></QuestionsInput>
          </OrderFlow>
        </div>
        <Modal
          @close="doCloseModal"
          :active="progress.show">
          <QuestionsProgress
            :headline="store.resources.QuestionsProgressHeadline"
            :states="progress.states"
            :show="progress.show"
            :begin="store.progressing"
            @finish="finishProgress"
          >
          </QuestionsProgress>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import t from './../../../mixins/t.js'
import Modal from './../../common/Modal'
import OrderFlow from './../../common/OrderFlow'
import QuestionCvr from './QuestionsCvr'
import QuestionsInput from './QuestionsInput'
import QuestionsProgress from './QuestionsProgress'

export default {
  name: 'Questions',
  props: {
    step: {
      default: String(0),
      type: String // Somehow when routing happens this get converted from Number to String
    },
    cvr: {
      type: String
    }
  },
  mixins: [t],
  components: {
    Modal,
    OrderFlow,
    QuestionCvr,
    QuestionsInput,
    QuestionsProgress
  },
  data () {
    return {
      store: this.$parent.store,
      progress: {
        show: false,
        states: require('./../../../entities/progressStates.json')
      }
    }
  },
  created () {
    if (!this.store.company) {
      // If no company (on refresh), set CVR and route to step 1
      if (this.cvr) {
        this.store.cvr = this.cvr
        this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(0) } })
      }
    }
    this.progress.states.map(state => { state.done = false })
  },
  methods: {
    // Helper function
    getStepModifier (currentStep) {
      return (String(currentStep) === this.step) ? 'extra-padding grey-medium' : 'extra-padding'
    },
    // Event
    doGotoStep (step) {
      if (step >= this.store.questions.length) {
        this.beginProgress()
      } else {
        this.progress.show = false
        this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(step) } })
      }
    },
    doCloseModal () {
      this.progress.show = false
    },
    doFindCvr () {
      this.$bus.$emit('app_getQuestions', this.store.cvr)
    },
    beginProgress () {
      this.progress.show = true
      if (this.store.config.insuranceLayout != null) {
        this.$bus.$emit('app_getInsuranceContact')
      } else {
        this.$bus.$emit('app_getInsurances')
      }
    },
    finishProgress () {
      this.store.progressing = false
      this.progress.show = false
      // Route
      if (this.store.config.insuranceLayout != null) {
        this.$router.push({ name: 'InsuranceContact', params: { cvr: this.store.cvr, contact: this.store.contact } })
      } else {
        this.$router.push({ name: 'Insurances', params: { cvr: this.store.cvr } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/questions/Questions.vue